import { enqueueSnackbar } from 'notistack';

import type { NotificationOptions, NotificationType } from './types';

export const addNotification = (
  message: string,
  variant: NotificationType,
  options?: NotificationOptions,
) => {
  enqueueSnackbar(message, {
    // Figma 20:4413: тост размещается справа внизу.
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    preventDuplicate: true,
    ...options,
    variant,
  });
};
